import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=17c88787&"
import script from "./DataTables.vue?vue&type=script&lang=ts&"
export * from "./DataTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c88787')) {
      api.createRecord('17c88787', component.options)
    } else {
      api.reload('17c88787', component.options)
    }
    module.hot.accept("./DataTables.vue?vue&type=template&id=17c88787&", function () {
      api.rerender('17c88787', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/v2/DataTables.vue"
export default component.exports